import Contract from "./Contract";
import File from "./File";

const StaticEntity = {
  Contract,
  File,
};

export default StaticEntity;
